import React from 'react';
import { Alert, Button } from 'reactstrap';
import { ChecklistOverview } from '../checklists/ChecklistOverview';
import { ChecklistEditor } from '../checklists/ChecklistEditor';
import { isLegacyChecklist } from '../checklists/utils';
import { ChecklistPropertiesPanel } from '../checklists/ChecklistPropertiesPanel';

export function GlobalChecklistEditorPanel({
    checklist,
    onClose,
    onSave,
}) {
    if (!checklist) {
        return null;
    }

    if (isLegacyChecklist(checklist)) {
        return (<>
            <Button
                close
                onClick={ onClose }
            >&times;</Button>

            <Alert color="info">
                <h5 className="alert-heading">
                    This checklist has been retired
                </h5>
                <hr />
                <p className="mb-0">
                    This is an older version of a checklist. While you can&apos;t modify it or attach it to any new jobs,
                    any existing jobs already using it will continue to function normally.
                </p>

                <p>
                    <strong>Tip</strong>You can copy this checklist to create a new, editable global version available to all brandings and properties.
                </p>
            </Alert>

            <ChecklistOverview checklist={ checklist } />
        </>);
    }

    return (
        <ChecklistEditor
            checklist={ checklist }
            onSave={ onSave }
        >
            <Button
                close
                onClick={ onClose }
            >&times;</Button>
            <ChecklistPropertiesPanel />
            <hr />
        </ChecklistEditor>
    );
}
